import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Grid, Col, Button, FormGroup, FormControl, Panel } from 'react-bootstrap'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth'
import firebase from '../firebase'
import * as helpers from '../lib/HelperFunctions'
import {Link} from 'react-router'

// Styles
import './css/firebaseui-styling.global.css' // Import globally.
import '../containers/css/Login.css'

class Login extends Component {
    constructor(props) {
        super(props)
        this.resetState = this.resetState.bind(this)
        this.state = {
            email: '',
            password: '',
            emailValid: false,
        }
  
        this.uiConfig = {
          // Called when the user has been successfully signed in.
          callbacks: {
            signInSuccess: (currentUser, credential, redirectUrl) => {
                //do not allow people in without email
                if(credential.providerId==='facebook.com' && currentUser.email===null){
                  props.stores.authStore.signOut() //TODO: we need to handle this more user friendly
                }else{
                  firebase.database().ref('users/'+currentUser.uid+'/credential').set(credential)
                }

              // Do not redirect.
              return false
            },
          },
          // Opens IDP Providers sign-in flow in a popup.
          signInFlow: 'popup',
          signInOptions: [
            {
              provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
              scopes: ['https://www.googleapis.com/auth/plus.login'],
            },
            {
              provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
              scopes: [
                'public_profile',
                'email',
                // 'user_likes',
                // 'user_friends'
              ],
            },
            // {
            //   provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            //   // Whether the display name should be displayed in Sign Up page.
            //   requireDisplayName: true,
            // },
          ],
          // Terms of service url.
          tosUrl: 'http://pre.do/terms-of-service/',
        }
    }
    resetState() {
      if(this){
        this.setState({
            password: '',
        })
      }
    }
    handleForgotPassword(){
      const {email} = this.state
      const {stores} = this.props
      const {store, authStore} = stores
      let thing = this

      store.infoAlert = 'Resetting Password, check your inbox.'
      window.setTimeout(() => { 
          store.infoAlert = undefined
      }, 5000)
      authStore.sendPasswordResetEmail({email})
      .then((success) => {thing.resetState()})
      .catch((error) => {thing.resetState()})
    }
  handleLogin() {
      const {email, password} = this.state
      const {stores} = this.props
      const {store, authStore} = stores
      store.infoAlert = 'Logging In...'
      window.setTimeout(() => { 
          store.infoAlert = undefined
      }, 3000)
      authStore.signIn({
          email,
          password,
      })
      .then((success)=> {
        this.resetState()
      })
      .catch((error) => {
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message

        if (errorCode === 'auth/user-not-found') {
          store.errorAlert = 'There is no user record corresponding to this identifier.'
          window.setTimeout(() => { store.errorAlert = undefined }, 8000)
        }else if(errorCode === 'auth/wrong-password'){
          store.errorAlert = 'The password is invalid or the user does not have a password.'
          window.setTimeout(() => { store.errorAlert = undefined }, 8000)
        }else{
          store.errorAlert = errorMessage
          window.setTimeout(() => { store.errorAlert = undefined }, 8000)
        }
        this.resetState()
      })
  }
  onPressEnterToSubmit(e){
    if(e.charCode === 13) {
      if(this.state.emailValid)
        this.handleLogin()
    }         
}

  handleEmailChange(e) {
      this.setState({email: e.target.value})
      if (helpers.validateEmail(e.target.value)){
          this.setState({emailValid:true})
      }else{
          this.setState({emailValid:false})
      }
  }
  handlePasswordChange(e) {
      this.setState({password: e.target.value})
  }
  
    render() {
      return (
          <Grid>
          <Col xs={10} xsOffset={1} md={4} mdOffset={4}>
            <div style={{display:'flex',justifyContent:'center'}}>
              <img src='/PreDo-logo.png' alt='PRE.DO' style={{width:'300px',height:'168px'}}/>
            </div>
            <Panel>
              <FormGroup controlId='formEmail'>
                {/* <ControlLabel>Email</ControlLabel> */}
                <FormControl
                  type='email'
                  placeholder='youremail@mail.com'
                  onChange={(e) => this.handleEmailChange(e)}
                />
              </FormGroup>
              <FormGroup controlId='formPassword'>
                {/* <ControlLabel>Password</ControlLabel> */}
                <FormControl
                  type='password'
                  placeholder='Password'
                  onChange={(e) => this.handlePasswordChange(e)}
                  onKeyPress={(e) => this.onPressEnterToSubmit(e)} 
                />
              </FormGroup>
              <div style={{display:'flex',justifyContent:'center'}}>
                <Button disabled={!this.state.emailValid} bsStyle='primary' onClick={(e) => this.handleLogin(e)}>
                    Log in
                </Button>
              </div>
              <div style={{display:'flex',justifyContent:'flex-end', paddingTop: 15+'px'}}>
                <Link to={{ pathname: '/forgot' }} style={{color:'black'}}> 
                  Forgot password?
                </Link>
              </div>
            </Panel>
            <div style={{display:'flex',justifyContent:'center'}}>
              OR
            </div>
            <StyledFirebaseAuth 
              // className={styles.firebaseUi} 
              uiConfig={this.uiConfig}
              firebaseAuth={firebase.auth()}
            />
            <div style={{display:'flex',justifyContent:'center'}}>
              New to PRE.DO?
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Link to={{ pathname: '/signup' }} > 
                <b>Sign Up</b>
              </Link>
            </div>
            </Col>
          </Grid>
      )
  }
}

export default inject('stores')(observer(Login))



// WEBPACK FOOTER //
// ./src/containers/Login.js